const routeModule = {
    namespaced: true,
    state: {
        lastRoute: {name: null}
    },
    getters: {
        getLastRoute: state => state.lastRoute
    },
    mutations: {
        SET_LAST_ROUTE: (state, value) => {
            state.lastRoute = value;
        }
    },
    actions: {
        setLastRoute: ({commit}, value) => {
            commit('SET_LAST_ROUTE', value);
            sessionStorage.setItem('lastRoute', value);
        }
    },
};

export default routeModule;